export const TEST_IDS = {
  NAV: {
    root: "navbar-root",
    logo: "navbar-logo",
    cartButton: "navbar-cart-button",
    comeOnIn: "navbar-come-on-in-btn",
    mobileMenu: "navbar-mobile-menu",
  },
  HERO: {
    root: "hero-section",
    headline: "hero-headline",
    subtext: "hero-subtext",
    shopCta: "hero-shop-cta",
    howItWorks: "hero-how-it-works",
  },
  PRODUCT: {
    card: (id) => `product-card-${id}`,
    badge: (id) => `checked-badge-${id}`,
    addToCart: (id) => `add-to-cart-${id}`,
    price: (id) => `product-price-${id}`,
    name: (id) => `product-name-${id}`,
    fit: (id) => `product-fit-${id}`,
  },
  SECTION: {
    wear: "section-wear",
    bigLiving: "section-big-living",
    manifesto: "section-manifesto",
  },
  CART: {
    drawer: "cart-drawer",
    itemCount: "cart-item-count",
    total: "cart-total",
    checkout: "cart-checkout-btn",
    removeItem: (id) => `cart-remove-${id}`,
    quantity: (id) => `cart-quantity-${id}`,
  },
  DETAIL: {
    root: "product-detail-root",
    title: "product-detail-title",
    price: "product-detail-price",
    addToCart: "product-detail-add-to-cart",
    description: "product-detail-description",
    image: "product-detail-image",
    backButton: "product-detail-back",
  },
  FOOTER: {
    root: "footer-root",
  },
};
